export default __webpack_public_path__ + "80f6d53e399ccfcbecb37cda82e79d2c.png";